import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import {
    HTTP_INTERCEPTORS,
    withInterceptorsFromDi,
    provideHttpClient,
} from '@angular/common/http';
import { TokenInterceptor } from './app/service/core/interceptor.service';
import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { AppRoutes } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app/app.component';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { AlterarSenhaGuard } from './app/auth/alterar-senha/alterar-senha-guard';


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            ConfirmDialogModule,
            ButtonModule,
            FontAwesomeModule
        ),
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: APP_BASE_HREF, useValue: '/' },
        // Após a primeira tela, baixa em segundo plano os chunks das demais rotas.
        // Sem isso, a navegação pelo menu espera o download encadeado dos módulos lazy
        // (as rotas usam vários `path: ''` + loadChildren) e a tela antiga fica parada.
        provideRouter(AppRoutes, withPreloading(PreloadAllModules)),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        MessageService,
        AlterarSenhaGuard,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    cssVars: true,
                    darkModeSelector: false || 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'styles, primeng, another-css-library'
                    }
                },
            },
        }),
    ],
}).catch((err) => console.error(err));
